<template >
  <base-material-card
    v-if="ifEnte"
    color="secondary"
    class="mx-5"
    icon="mdi-thumb-up"
  >
    <template v-slot:after-heading>
      <div class="display-1 mt-2 font-weight-light">
        {{ $t("approve_association") }}
      </div>
    </template>
    <v-layout
      class="mx-12"
      row
    >
      <v-tabs
        v-model="tabs"
        background-color="transparent"
        color="secondary"
        slider-color="secondary"
      >
        <v-tab
          class="mr-3"
          v-if="approve_association"
        >
          <v-icon class="mr-2">mdi-bank</v-icon>
          {{ $t("approve_association") }}
        </v-tab>
        <v-tab
          class="mr-3"
          v-if="approve_council"
        >
          <v-icon class="mr-2">mdi-account-group</v-icon>
          {{ $t("approve_council") }}
        </v-tab>
        <v-tab
          class="mr-3"
          v-if="approve_document"
        >
          <v-icon class="mr-2">mdi-file-document-outline</v-icon>
          {{ $t("approve_asd_documents") }}
        </v-tab>
      </v-tabs>
    </v-layout>

    <v-tabs-items
      v-model="tabs"
      class="transparent tabs-container"
    >
      <v-tab-item v-if="approve_association">
        <edit-associazione
          :title="$t('approve_asociation')"
          type="plain"
          parmsMethod="APPROVE"
          :parmsAsdCode="asdCode"
          @isUpdated="loadData"
        />
      </v-tab-item>
      <v-tab-item v-if="approve_council">
        <edit-consiglio
          :title="$t('approve_council')"
          type="plain"
          parmsMethod="APPROVE"
          :parmsAsdCode="asdCode"
          @isUpdated="loadData"
        />
      </v-tab-item>
      <v-tab-item v-if="approve_document">
        <edit-documenti
          :title="$t('approve_asd_document')"
          type="plain"
          @isUpdated="loadData"
          parmsMethod="APPROVE"
          :parmsAsdCode="asdCode"
        ></edit-documenti>
      </v-tab-item>
    </v-tabs-items>
  </base-material-card>
</template>
<script>
import gestAssociazione from "@/app/ente/gestAssociazione.vue";
import gestConsiglio from "@/app/ente/gestConsiglio.vue";
import gestDocumenti from "@/app/ente/gestDocumenti.vue";

export default {
  name: "ente-admin-panel",
  components: {
    "edit-associazione": gestAssociazione,
    "edit-consiglio": gestConsiglio,
    "edit-documenti": gestDocumenti,
  },
  props: {
    asdCode: null,
  },
  data() {
    return {
      ifEnte: false,
      approve_association: true,
      approve_council: true,
      approve_document: true,
      tabs: 0,
    };
  },
  methods: {
    loadData() {
      let _ = this;
      _.approve_association = false;
      _.approve_council = false;
      _.approve_document = false;
      _.chiamataAxios("GET", "auth/ente/getInfo2approve/" + _.asdCode).then(
        (response) => {
          _.approve_association = response.data.asdInfo;
          _.approve_council = response.data.consiglio;
          _.approve_document = response.data.documenti;
        }
      );
    },
  },
  created() {
    let _ = this;
    _.ifEnte = window.systemData.ifEnte;
    _.loadData();
  },

  watch: {
    asdCode: function (newVal, oldVal) {
      // watch it
      if (newVal) _.loadData();
    },
  },
};
</script>
